export const alpha = (a, b) => a < b ? -1 : a > b ? 1 : 0;
export const date = (a, b) => { let aDate = new Date(a), bDate = new Date(b); return aDate < bDate ? -1 : aDate > bDate ? 1 : 0 };
export const sortOrder = (a, b) => a.sortOrder < b.sortOrder ? -1 : a.sortOrder > b.sortOrder ? 1 : 0;

export default { alpha, date, sortOrder }
